import UIComponent from "../component";
class Input extends UIComponent {
    value(value = null) {
        if (value === null) {
            return this.element.value;
        }
        return this.element.value = value;
    }
}

export default Input;
export { Input };


